export const HOTELS_DATA_NOT_FOUND_MESSAGE = 'Hotels data not found'
export const FETCH_SEARCH_IN_PLACE_HTTP_ERROR_PREFIX =
	'Error in fetchSearchInPlace: HTTP'
export const buildFetchSearchInPlaceHttpErrorMessage = (status: number) =>
	`${FETCH_SEARCH_IN_PLACE_HTTP_ERROR_PREFIX} ${status}`
export const FETCH_HOTELS_ERROR_MESSAGE = 'Error in fetching hotels'
export const DIRECT_VIEW_GA_EVENT_MESSAGE = 'Direct view GA event fired'

const REPLAY_SKIP_MESSAGE_FRAGMENTS = [
	HOTELS_DATA_NOT_FOUND_MESSAGE,
	FETCH_SEARCH_IN_PLACE_HTTP_ERROR_PREFIX,
	FETCH_HOTELS_ERROR_MESSAGE,
	DIRECT_VIEW_GA_EVENT_MESSAGE,
] as const

export const getSentryEventErrorMessage = (event: {
	exception?: { values?: Array<{ value?: string }> }
	message?: string
}) => event.exception?.values?.[0]?.value ?? event.message ?? ''

export const shouldSkipReplayForError = (
	event: Parameters<typeof getSentryEventErrorMessage>[0]
): boolean => {
	const message = getSentryEventErrorMessage(event)
	return REPLAY_SKIP_MESSAGE_FRAGMENTS.some((fragment) =>
		message.includes(fragment)
	)
}
